import {filterDOMProps as $9XpHW$filterDOMProps, useId as $9XpHW$useId, mergeProps as $9XpHW$mergeProps, useSlotId as $9XpHW$useSlotId, isMac as $9XpHW$isMac, isWebKit as $9XpHW$isWebKit} from "@react-aria/utils";
import {useFocusWithin as $9XpHW$useFocusWithin, useHover as $9XpHW$useHover, isFocusVisible as $9XpHW$isFocusVisible} from "@react-aria/interactions";
import {useLabel as $9XpHW$useLabel} from "@react-aria/label";
import {useSelectableList as $9XpHW$useSelectableList, useSelectableItem as $9XpHW$useSelectableItem} from "@react-aria/selection";
import {getItemCount as $9XpHW$getItemCount} from "@react-stately/collections";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $4599f731efac101a$exports = {};

$parcel$export($4599f731efac101a$exports, "useListBox", () => $4599f731efac101a$export$50eacbbf140a3141);

var $fc40a93251bc17d1$exports = {};

$parcel$export($fc40a93251bc17d1$exports, "listData", () => $fc40a93251bc17d1$export$3585ede4d035bf14);
$parcel$export($fc40a93251bc17d1$exports, "getItemId", () => $fc40a93251bc17d1$export$9145995848b05025);
const $fc40a93251bc17d1$export$3585ede4d035bf14 = new WeakMap();
function $fc40a93251bc17d1$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $fc40a93251bc17d1$export$9145995848b05025(state, itemKey) {
    let data = $fc40a93251bc17d1$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error('Unknown list');
    return `${data.id}-option-${$fc40a93251bc17d1$var$normalizeKey(itemKey)}`;
}






function $4599f731efac101a$export$50eacbbf140a3141(props, state, ref) {
    let domProps = $9XpHW$filterDOMProps(props, {
        labelable: true
    });
    let { listProps: listProps  } = $9XpHW$useSelectableList({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys
    });
    let { focusWithinProps: focusWithinProps  } = $9XpHW$useFocusWithin({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = $9XpHW$useId(props.id);
    $fc40a93251bc17d1$export$3585ede4d035bf14.set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized
    });
    let { labelProps: labelProps , fieldProps: fieldProps  } = $9XpHW$useLabel({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    return {
        labelProps: labelProps,
        listBoxProps: $9XpHW$mergeProps(domProps, focusWithinProps, state.selectionManager.selectionMode === 'multiple' ? {
            'aria-multiselectable': 'true'
        } : {
        }, {
            role: 'listbox',
            ...$9XpHW$mergeProps(fieldProps, listProps)
        })
    };
}


var $320d38f7a0623e79$exports = {};

$parcel$export($320d38f7a0623e79$exports, "useOption", () => $320d38f7a0623e79$export$497855f14858aa34);





function $320d38f7a0623e79$export$497855f14858aa34(props, state, ref) {
    let { key: key  } = props;
    let data = $fc40a93251bc17d1$export$3585ede4d035bf14.get(state);
    var _isDisabled;
    let isDisabled = (_isDisabled = props.isDisabled) !== null && _isDisabled !== void 0 ? _isDisabled : state.disabledKeys.has(key);
    var _isSelected;
    let isSelected = (_isSelected = props.isSelected) !== null && _isSelected !== void 0 ? _isSelected : state.selectionManager.isSelected(key);
    let isFocused = state.selectionManager.focusedKey === key;
    var _shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _shouldSelectOnPressUp !== void 0 ? _shouldSelectOnPressUp : data.shouldSelectOnPressUp;
    var _shouldFocusOnHover;
    let shouldFocusOnHover = (_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _shouldFocusOnHover !== void 0 ? _shouldFocusOnHover : data.shouldFocusOnHover;
    var _shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _shouldUseVirtualFocus !== void 0 ? _shouldUseVirtualFocus : data.shouldUseVirtualFocus;
    var _isVirtualized;
    let isVirtualized = (_isVirtualized = props.isVirtualized) !== null && _isVirtualized !== void 0 ? _isVirtualized : data.isVirtualized;
    let labelId = $9XpHW$useSlotId();
    let descriptionId = $9XpHW$useSlotId();
    let optionProps = {
        role: 'option',
        'aria-disabled': isDisabled,
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!($9XpHW$isMac() && $9XpHW$isWebKit())) {
        optionProps['aria-label'] = props['aria-label'];
        optionProps['aria-labelledby'] = labelId;
        optionProps['aria-describedby'] = descriptionId;
    }
    if (isVirtualized) {
        optionProps['aria-posinset'] = state.collection.getItem(key).index + 1;
        optionProps['aria-setsize'] = $9XpHW$getItemCount(state.collection);
    }
    let { itemProps: itemProps , isPressed: isPressed  } = $9XpHW$useSelectableItem({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps  } = $9XpHW$useHover({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!$9XpHW$isFocusVisible()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        optionProps: {
            ...optionProps,
            ...$9XpHW$mergeProps(itemProps, hoverProps),
            id: $fc40a93251bc17d1$export$9145995848b05025(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed
    };
}


var $da55f015385fe4fc$exports = {};

$parcel$export($da55f015385fe4fc$exports, "useListBoxSection", () => $da55f015385fe4fc$export$c3f9f39876e4bc7);

function $da55f015385fe4fc$export$c3f9f39876e4bc7(props) {
    let { heading: heading , 'aria-label': ariaLabel  } = props;
    let headingId = $9XpHW$useId();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            'aria-hidden': true
        } : {
        },
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}





export {$4599f731efac101a$export$50eacbbf140a3141 as useListBox, $320d38f7a0623e79$export$497855f14858aa34 as useOption, $da55f015385fe4fc$export$c3f9f39876e4bc7 as useListBoxSection, $fc40a93251bc17d1$export$3585ede4d035bf14 as listData, $fc40a93251bc17d1$export$9145995848b05025 as getItemId};
//# sourceMappingURL=module.js.map
